import '../MainFrame.css';
import "./Home.css";

import { getPreviewEvents } from '../../../Services/Calendar.js'
import { useEffect, useState } from 'react';

function Home(props) {

  const [events, setEvents] = useState([]);

  const loadEvents = async () => {
    let rsp = await getPreviewEvents();

    if(rsp?.Error === false){
      for(let i = 0; i < rsp.Data.length; i++){
        rsp.Data[i].start = rsp.Data[i].start.slice(5, 10);
      }
      setEvents(rsp.Data);
    }
  }
  useEffect(() => {
    loadEvents();
  }, []);


  return(
    <div className='frame home-frame'>
      <section className="campus-hero">
        <div className="hero-copy">
          <span className="eyebrow">Campus 360</span>
          <h1>Hola, {props.usrData.name}</h1>
          <p>Tu cursada, mensajes y calendario en un espacio mas claro para avanzar sin perder tiempo.</p>
          <div className="hero-actions">
            <button className="primary-action" onClick={() => props.setActualFrame('cursadas')}>Ver cursadas</button>
            <button className="secondary-action" onClick={() => props.setActualFrame('buzon')}>Abrir buzon</button>
          </div>
        </div>
      </section>

      <section className="home-grid">
        <button className="home-action-card" onClick={() => props.setActualFrame('cursadas')}>
          <span>01</span>
          <h3>Cursadas</h3>
          <p>Continua tus modulos y actividades pendientes.</p>
        </button>
        <button className="home-action-card" onClick={() => props.setActualFrame('calendar')}>
          <span>02</span>
          <h3>Calendario</h3>
          <p>Revisa fechas, entregas y proximos encuentros.</p>
        </button>
        <button className="home-action-card" onClick={() => props.setActualFrame('contactos')}>
          <span>03</span>
          <h3>Contactos</h3>
          <p>Manten cerca a docentes y companeros.</p>
        </button>

        <aside className="events-panel">
          <div className="panel-heading">
            <span>Agenda</span>
            <button onClick={() => props.setActualFrame('calendar')}>Ver todos</button>
          </div>
          <div className="event-list">
            {
              events.length === 0 ?
              <p className="empty-state">No se registran eventos proximos.</p>
              :
              events.map((item, index) => {
                return(
                  <button className='event-row' key={index + 'stph'} onClick={() => props.setActualFrame('calendar')}>
                    <strong>{item.start.trim(' ')}</strong>
                    <span>{item.title}</span>
                  </button>
                )
              })
            }
          </div>
        </aside>
      </section>
    </div>
  );
}


export default Home
